import moment from 'moment-timezone';

export const setTimezone = (date, timezone) => {
  const noTimezoneDate = date.format('YYYY-MM-DD HH:mm');
  return moment.tz(noTimezoneDate, timezone);
};

export const setNoon = date =>
  date
    .hour(12)
    .minute(0)
    .second(0)
    .millisecond(0);

export const getDateFromMoment = momentDate => moment(momentDate.format('YYYY-MM-DD HH:mm')).toDate();
